import React from 'react';
import styled from 'styled-components';

const FormErrorS = styled.div`
  font-size: 12px;
  color: red;
  margin: 5px 0;
`;

export function FormError(props) {
  return <FormErrorS {...props} />;
}
